<script>
export default {
  name: 'EventSelectionOddsRow',
  props: {
    selectionOdds: {
      type: Object,
      required: true,
    },
  },
  computed: {
    selectionPrice() {
      const { price } = this.selectionOdds;
      return price ? `$${price.value}` : '';
    },
  },
};
</script>

<template>
  <div class="event-select-odds-row">
    <div class="event-select-odds-row__container">
      <div class="event-select-odds-row__left">
        <div :class="`event-select-odds-row__logo logo-${selectionOdds.bookmakerId}`"></div>
        <div class="event-select-odds-row__bookie-name">{{ selectionOdds.bookmakerId }}</div>
      </div>
      <div class="event-select-odds-row__right">
        <div :class="`event-select-odds-row__price`">{{ selectionPrice }}</div>
        <a :href="`/link/${selectionOdds.bookmakerId}`" class="event-select-odds-row__join-btn">Join</a>
      </div>
    </div>
  </div>
</template>
